// packages/validation/src/merchantRule.ts
import { z } from 'zod';

export const merchantPatternSchema = z
  .string()
  .trim()
  .min(1, 'Pattern required')
  .max(120, 'Pattern too long');

export const createRuleBodySchema = z.object({
  pattern: merchantPatternSchema,
  categorySlug: z.string().trim().min(1).max(60),
});

export const updateRuleBodySchema = z
  .object({
    pattern: merchantPatternSchema.optional(),
    categorySlug: z.string().trim().min(1).max(60).optional(),
  })
  .refine((v) => v.pattern !== undefined || v.categorySlug !== undefined, {
    message: 'At least one field required',
  });
